import { Fragment } from 'react';

type Props = {
  lots?: string | null;
};

/*
  An endorsement's lots as the API sends them, one string: "54hd:1_2345, 43hd:FC-2026-02" (built by
  the backend's EndorsementLotsHelper). Each lot is kept on one line so a narrow cell wraps between
  lots, not at a hyphen or space inside a container name ("43hd:FC-" over "2026-02"). Shown by the
  Lots column on LRP Claims and the Current Lots field on the SCE Details dialog.
*/
export default function LrpLots({ lots }: Props) {
  return (
    <>
      {lots?.split(', ').map((lot, i) => (
        // A claim can list the same lot twice, so the index is part of the key.
        <Fragment key={`${i}-${lot}`}>
          {i > 0 && ', '}
          <span style={{ whiteSpace: 'nowrap' }}>{lot}</span>
        </Fragment>
      ))}
    </>
  );
}
